import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Chip, ChipProps, Tooltip } from '@mui/material';
import clsx from 'clsx';
import style from './index.module.scss';

interface Props extends ChipProps {
  value: boolean;
  title: string;
}

export const ActivitiesStatus: React.FC<React.PropsWithChildren<Props>> = ({ value, title }) => {
  return (
    <Tooltip title={title}>
      <Chip
        size={'medium'}
        avatar={value ? <CheckIcon /> : <CloseIcon />}
        label={title}
        classes={{
          root: clsx(value && style.rootActive),
          avatar: clsx(value && style.avatarActive),
        }}
      />
    </Tooltip>
  );
};
